<div
    #grabber
    class="grabber"
    draggable="true"
    (mousedown)="onMouseDown()"
>
    <div class="line">
    </div>
</div>
